import { render } from "./service-detail.vue?vue&type=template&id=8c00fc58&scoped=true"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"

import "./service-detail.vue?vue&type=style&index=0&id=8c00fc58&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c00fc58"]])

export default __exports__